import { DateStr, PntStationStatusReportDto, today } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../core/reports/types';
import { ScheduleStatusMentionsForm } from './form';
import { ScheduleStatusMentionsResult } from './result';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
}

export type ScheduleStatusMentionsReport = ReportType<
  { date: DateStr; customId: string },
  PntStationStatusReportDto
>;

export function ScheduleStatusPntView(p: Props) {
  return (
    <ReportView<ScheduleStatusMentionsReport>
      defaultValues={{
        date: today() as DateStr,
        customId: '',
      }}
      runOnLoad
      download={false}
      reportFn={async (values) => {
        return apiClient.audit.stationReportsScheduleStatusPnt({
          stationId: p.station.id,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={ScheduleStatusMentionsForm}
      Result={ScheduleStatusMentionsResult}
    />
  );
}
